<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-t-15">
    <div class="row">
      <div class="col-lg-3">
        <div class="card-ocupabilidad">
          <h3 class="f-s-14">Ocupabilidad del Mes</h3>
          <div class="barra-container">
            <div class="barra" [style.width.%]="occupancy" [ngClass]="{
                   'verde': occupancy >= 70,
                   'amarillo': occupancy >= 40 && occupancy < 70,
                   'rojo': occupancy < 40
                 }">
            </div>
          </div>
          <p class="porcentaje">{{ occupancy }}%</p>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card-ocupabilidad">
          <h3 class="f-s-14">N° Reservas</h3>
          <div class="mini-stat-icon float-right" style="margin-top: -35px;">
            <i class="fas fa-clipboard-list bg-primary text-white f-s-25" style="width: 50px; height: 50px; line-height: 50px;"></i>
          </div>
          <h3 class="f-s-25">{{total_bookings}}<span class="dashboard__labelCard" style="right: 20px;">registrados</span></h3>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card-ocupabilidad">
          <h3 class="f-s-14">N° Huéspedes</h3>
          <div class="mini-stat-icon float-right" style="margin-top: -35px;">
            <i class="fas fa-users bg-info text-white f-s-25" style="width: 50px; height: 50px; line-height: 50px;"></i>
          </div>
          <h3 class="f-s-25">{{total_pax}}<span class="dashboard__labelCard" style="right: 20px;">registrados</span></h3>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card-ocupabilidad">
          <h3 class="f-s-14">Noches reservadas</h3>
          <div class="mini-stat-icon float-right" style="margin-top: -35px;">
            <i class="fas fa-moon bg-dark text-white f-s-25" style="width: 50px; height: 50px; line-height: 50px;"></i>
          </div>
          <h3 class="f-s-25">{{total_nights}} <span class="f-s-14" style="font-weight: 500;">/{{nights_month}}</span><span class="dashboard__labelCard" style="right: 20px;">registrados</span></h3>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-l-0 p-r-0">
      <div class="calendar-container p-l-0 p-r-0">
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
      </div>    
    </div>


    <!-- Modal detalle reserva -->
    <div id="modalEventBooking" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content" *ngIf="eventObj != null">
          <div class="modal-header p-t-10 p-b-10">
            <h5 class="modal-title bold f-s-15 w-100">
              HAB {{eventObj.code_number}} : <span
                class="badge badge-primary f-s-12">{{eventObj.roomtype_booking.description}}</span>
              <span class="badge float-right text-white f-s-13" [ngStyle]="{'background-color': eventObj.color}">
                Estado: {{ eventObj.checkin_status }}
              </span>
            </h5>
            <a type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalEventObj()">
              <span aria-hidden="true">&times;</span>
            </a>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-9 form-group">
                <label class="m-b-5"><i class="fas fa-user m-r-5"></i>Titular Reserva</label>
                <div>{{eventObj.booking.client_data.fullname}}</div>
              </div>
              <div class="col-lg-2 form-group">
                <label class="m-b-5">Documento</label>
                <div>{{eventObj.booking.client_data.document}}</div>
              </div>
            </div>
            <hr style="margin: 5px 0;">
            <div class="row">
              <div class="col-lg-3 form-group">
                <label class="m-b-5"><i class="fas fa-plane-arrival m-r-5 text-success"></i>Ingreso</label>
                <div>{{eventObj.inicio}}</div>
              </div>
              <div class="col-lg-3 form-group">
                <label class="m-b-5"><i class="fas fa-plane-departure m-r-5 text-danger"></i>Salida</label>
                <div>{{eventObj.fin}}</div>
              </div>
              <div class="col-lg-3 form-group">
                <label class="m-b-5 text-center">N° Noches</label>
                <div class="text-center">{{eventObj.number_nights}}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal"
              (click)="closeModalEventObj()">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- =============== -->
  </div>
